import { useState } from "react";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { APP_META_TRAVEL_ADS_API_ENDPOINT } from "../../../../constants/api_urls";
import { getUserToken } from "../../../../utils/functions/userToken";

const useSaveAdsCreative = () => {
  const [isLoading, setIsLoading] = useState(false);
  const token = getUserToken();

  const saveAdsCreative = async ({
    effectiveCampaignId,
    adsCreativeCards,
    setDrawerOpen,
    onClose
  }) => {
    try {
      setIsLoading(true);
      setDrawerOpen(true);

      const payload = {
        campaign_id: effectiveCampaignId,
        campaign_ads_creative: adsCreativeCards.map((card, i) => ({
          ad_card_id: card?.ad_card_id,
          ad_language_id: card?.ad_language_id, // Language ID
          hotel_id: card?.hotel_id || null, // Hotel ID for multi-hotel campaigns
          headline: {
            assetContent: card?.headline?.assetContent,
          },
          primary_text: {
            assetContent: card?.primary_text?.assetContent,
          },
          call_to_action: {
            assetContent: card?.call_to_action?.assetContent,
          },
          feed_link_description: {
            assetContent: card?.feed_link_description?.assetContent,
          },
          web_site_url: {
            url: card?.web_site_url?.url,
          },
          deep_link_to_website: {
            url: card?.deep_link_to_website?.url,
          },
          marketing_image: {
            url: card?.marketing_image?.url,
          },
          multi_advertiser_ads: card?.multi_advertiser_ads,
          marketing_image_source: card?.marketing_image_source || 'CATALOGUE',
        })),
      };

      await axios.put(
        `${APP_META_TRAVEL_ADS_API_ENDPOINT}/api/meta-ads/edit-campaign/ads-creative/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      enqueueSnackbar("Ads creative saved successfully!", { variant: "success" });
      onClose();
    } catch (error) {
      console.error("Error saving ads creative:", error);
      const data = error?.response?.data;
      const creativeErrors = data?.campaign_ads_creative;

      if (!creativeErrors) {
        enqueueSnackbar(data?.errorMessage || "An unexpected error occurred", { variant: "error" });
      } else {
        Object.keys(creativeErrors || {}).forEach((key) => {
          const messages = creativeErrors[key];
          if (Array.isArray(messages)) {
            messages.forEach((msg) => {
              enqueueSnackbar(`${msg?.errorMessage}`, { variant: "error" });
            });
          }
        });
      }
    } finally {
      setIsLoading(false);
      setDrawerOpen(false);
    }
  };

  return {
    saveAdsCreative,
    isLoading
  };
};

export default useSaveAdsCreative;